<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <h4 class="card-title mb-0 pt-50">
          MSA</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <validation-observer
      v-show="!showTemplate"
      ref="simpleRules"
    >
      <b-form class="ex-large">
        <app-timeline>
          <app-timeline-item class="pb-1">
            <b-row>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Company Name</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Company Name"
                    rules="required"
                  >
                    <b-form-input
                      id="employer_company_name"
                      v-model="addMSA.employer_company_name"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Federal Tax Id</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Federal Tax Id"
                    rules="required|regex:^(\d){2}-(\d){7}$"
                  >
                    <b-form-input
                      id="federal_tax_id"
                      v-model="addMSA.federal_tax_id"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Address</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Address"
                    rules="required"
                  >
                    <b-form-input
                      id="address"
                      v-model="addMSA.address"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Contact Email</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Contact Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="email"
                      v-model="addMSA.email"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Payment Terms</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Payment Terms"
                    rules="required|integer|digits:2"
                  >
                    <b-form-input
                      id="email"
                      v-model="addMSA.payment_terms"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>Contact Name</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Contact Name"
                    rules="required"
                  >
                    <b-form-input
                      id="contact_name"
                      v-model="addMSA.contact_name"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
                lg="4"
              >
                <b-form-group>
                  <label>State</label>
                  <validation-provider
                    v-slot="{ errors }"
                    name="State"
                    rules="required"
                  >
                    <b-form-input
                      id="state"
                      v-model="addMSA.state"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
          </app-timeline-item>
        </app-timeline>
        <hr>

        <b-row class="mt-1">
          <b-col class="text-right">
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="updateContent"
            >
              Update Content
            </b-button>
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="generatePdf"
            >
              Generate Pdf
            </b-button>
            <b-button
              variant="primary"
              type="button"
              @click="sentForSign"
            >
              Send for E-Sign
            </b-button>
          </b-col>
        </b-row>

      </b-form>
    </validation-observer>

    <b-modal
      ref="validFor"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      size="sm"
      centered
      title="Valid For"
    >
      <validation-observer
        ref="valid_form"
        tag="form"
      >
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Valid For</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="Valid For"
                  rules="required|integer|between:1,11"
                >
                  <b-form-input
                    v-model="addMSA.valid_for"
                    placeholder="Valid For"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <b-button
            variant="outline-primary"
            class="px-1"
            @click="closeValidFor()"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="ml-1 px-1"
            @click="sendForSignature()"
          >
            Send
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      ref="updateContentValidFor"
      cancel-variant="outline-secondary"
      ok-title="Save"
      cancel-title="Close"
      size="sm"
      centered
      title="Valid For"
    >
      <validation-observer
        ref="update_valid_form"
        tag="form"
      >
        <b-form>
          <b-row>
            <b-col cols="12">
              <b-form-group>
                <label>Valid For</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="Valid For"
                  rules="required|integer|between:1,11"
                >
                  <b-form-input
                    v-model="template.valid_for"
                    placeholder="Valid For"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <template #modal-footer>
        <div class="d-flex justify-content-between w-100">
          <b-button
            variant="outline-primary"
            class="px-1"
            @click="closeUpdateValidFor()"
          >
            Cancel
          </b-button>
          <b-button
            variant="primary"
            class="ml-1 px-1"
            @click="sendForUpdateContentSignature()"
          >
            Send
          </b-button>
        </div>
      </template>
    </b-modal>

    <validation-observer
      v-show="showTemplate"
      ref="templateRules"
    >
      <b-form class="ex-large">
        <b-row>
          <b-col
            cols="12"
            md="10 ml-auto mr-auto"
          >
            <b-form-group>
              <div class="msa-form">
                <div class="mb-4">
                  <b-img
                    fluid
                    :src="template.logo"
                    alt="Company Logo"
                  />
                </div>
                <h4 class="text-center mb-1">
                  CONTRACTOR AGREEMENT</h4>
                <p
                  id="template_content"
                  v-html="template.template_response"
                />
                <div class="content-footer mt-4">
                  <b-row>
                    <b-col cols="6">
                      <h5>{{ template.company_name }}</h5>
                      <div class="mt-2 mb-50">
                        ________________________________
                        <span class="small d-block">(Signature)</span>
                      </div>
                      <h6>Print Name: {{ template.company_user_name }}</h6>
                      <h6>Title: {{ template.company_user_title }}</h6>
                      <h6>Email: {{ template.company_user_email }}</h6>
                      <h6>FED ID: {{ template.company_federal_tax_id }}</h6>
                    </b-col>
                    <b-col cols="6">
                      <h5>Contractor: {{ template.employer_company_name }}</h5>
                      <div class="mt-2 mb-50">
                        ________________________________
                        <span class="small d-block">(Signature)</span>
                      </div>
                      <h6>Print Name: {{ template.name }}</h6>
                      <div style="display: flex;">
                        <h6 class="title-edit">Title: </h6>
                        <input type="text" class="title-edit-input" v-model="template.title" />
                      </div>
                      <h6>Email: {{ template.email }}</h6>
                      <h6>FED ID: {{ template.federal_tax_id }}</h6>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <hr>

        <b-row class="mt-1">
          <b-col class="text-right">
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="back"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="generatePdfWithUpdatedContent"
            >
              Generate Pdf
            </b-button>
            <b-button
              variant="primary"
              type="button"
              class="mx-2"
              @click="sendForESignWithUpdatedContent"
            >
              Send for E-Sign
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BRow, BCol, BForm, BModal, BFormGroup, BFormInput, BImg, BButton,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import Ripple from 'vue-ripple-directive'
import {
  required,
} from '@validations'
import MSA from '@/js/msa'

export default {
  name: 'EmployerMSA',
  components: {
    BCard,
    BModal,
    AppTimeline,
    AppTimelineItem,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BImg,
    BButton,
    // currency,
  },
  directives: {
    Ripple,
  },
  setup() {
  },
  data() {
    return {
      required,
      addMSA: {
        compan_name: '',
        federal_tax_id: '',
        email: '',
        contact_name: '',
        address: '',
        state: '',
        valid_for: 5,
      },
      showTemplate: false,
      updateMsa: {
        template_response: '',
      },
      template: {
        template_response: '',
        logo: '',
        name: '',
        title: '',
        email: '',
        valid_for: 5,
      },
      date: null,
      formstate: {},
      submitted: false,
    }
  },
  watch: {
  },
  mounted() {
  },
  created() {
    MSA.getEmployerMsaById(this, this.$route.params.id)
  },
  destroyed() {
  },
  methods: {
    sendForSignature() {
      this.$refs.valid_form.validate().then(result => {
        if (result) {
          this.showLoading = true
          MSA.sendEmployerMsaForSign(this, this.$route.params.id, this.addMSA)
        }
      })
    },
    sentForSign() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          this.$refs.validFor.show()
        }
      })
    },
    closeValidFor() {
      this.$refs.validFor.hide()
    },
    generatePdf() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          this.showLoading = true
          MSA.getEmployerMsaPdfById(this, this.$route.params.id, this.addMSA)
        }
      })
    },
    updateContent() {
      this.$refs.simpleRules.validate().then(result => {
        if (result) {
          this.showLoading = true
          MSA.getEmployerMsaTemplateById(this, this.$route.params.id, this.addMSA)
        }
      })
    },
    generatePdfWithUpdatedContent() {
      this.$refs.templateRules.validate().then(result => {
        if (result) {
          this.template.template_response = document.getElementById('template_content').innerHTML.replaceAll('\n', '')
          this.showLoading = true
          MSA.getMsaPdfByIdAndUpdatedContent(this, this.$route.params.id, this.template)
        }
      })
    },
    closeUpdateValidFor() {
      this.$refs.updateContentValidFor.hide()
    },
    sendForUpdateContentSignature() {
      this.$refs.update_valid_form.validate().then(result => {
        if (result) {
          this.template.template_response = document.getElementById('template_content').innerHTML.replaceAll('\n', '')
          this.showLoading = true
          MSA.sendMsaUpdatedContentForSign(this, this.$route.params.id, this.template)
        }
      })
    },
    sendForESignWithUpdatedContent() {
      this.$refs.templateRules.validate().then(result => {
        if (result) {
          this.template.template_response = document.getElementById('template_content').innerHTML.replaceAll('\n', '')
          this.$refs.updateContentValidFor.show()
        }
      })
    },
    setEmployerDetails(msaDetails) {
      this.addMSA = msaDetails
      this.addMSA.valid_for = 5
    },
    pdfPath(data) {
      window.open(data.pdf_path, '_blank')
      this.back()
    },
    msaTemplate(data) {
      this.showTemplate = true
      this.template = data
      this.template.valid_for = 5
    },
    pdfNotFound(message) {
      this.$swal({
        icon: 'warning',
        title: 'MSA!',
        text: message,
      })
    },
    sentSuccess(data) {
      this.$refs.showLoading = false
      this.back()
      this.$swal({
        title: 'Success!',
        text: data.return_message,
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    sentFailure(message) {
      this.$refs.showLoading = false
      this.$swal({
        title: 'Error!',
        text: message,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
